<template>
  <div id="userLoginPage">
    <h2 style="margin-bottom: 16px">设置题目</h2>
    <a-form
      :model="questionContent"
      auto-label-width
      label-align="left"
      style="width: 480px"
      @submit="handleSubmit"
    >
      <a-form-item label="应用 id">
        {{ appId }}
      </a-form-item>
      <a-form-item :content-flex="false" :merge-props="false" label="题目列表">
        <a-space>
          <a-button @click="addQuestion(questionContent.length)"
            >底部添加题目
          </a-button>
          <AiGenerateQuestionDrawer
            :appId="appId"
            :on-success="onAiGenerateSuccess"
            :onSSEStart="onSSEStart"
            :onSSEClose="onSSEClose"
            :on-s-s-e-success="onAiGenerateSuccessSSE"
          ></AiGenerateQuestionDrawer>
        </a-space>
        <!--遍历每道题目-->
        <div v-for="(question, index) in questionContent" :key="index">
          <a-space size="large">
            <h3>题目 {{ index + 1 }}</h3>
            <a-button status="success" @click="addQuestion(index + 1)"
              >添加题目
            </a-button>
            <a-button status="danger" @click="deleteQuestion(index)"
              >删除题目
            </a-button>
          </a-space>
          <a-form-item :label="`题目 ${index + 1} 标题`" field="posts.post1">
            <a-input
              v-model="question.title"
              placeholder="请输入标题"
            ></a-input>
          </a-form-item>
          <!--题目选项-->
          <a-space>
            <h4>题目 {{ index + 1 }} 选项列表</h4>
            <a-button
              size="small"
              @click="addQuestionOption(question, question.options.length)"
              >底部添加选项</a-button
            >
          </a-space>
          <a-form-item
            v-for="(option, optionIndex) in question.options"
            :key="optionIndex"
            :label="`选项 ${optionIndex + 1}`"
            :content-flex="false"
            :merge-props="false"
          >
            <a-form-item label="选项键">
              <a-input
                v-model="option.key"
                placeholder="请输入选项键"
              ></a-input>
            </a-form-item>
            <a-form-item label="选项值">
              <a-input
                v-model="option.value"
                placeholder="请输入选项值"
              ></a-input>
            </a-form-item>
            <a-form-item label="选项结果">
              <a-input
                v-model="option.result"
                placeholder="请输入选项结果"
              ></a-input>
            </a-form-item>
            <a-form-item label="选项得分">
              <a-input-number
                v-model="option.score"
                placeholder="请输入选项得分"
              ></a-input-number>
            </a-form-item>
            <a-space size="large">
              <a-button
                status="success"
                size="mini"
                @click="addQuestionOption(question, optionIndex + 1)"
              >
                添加选项
              </a-button>
              <a-button
                status="danger"
                size="mini"
                @click="deleteQuestionOption(question, optionIndex)"
              >
                删除选项
              </a-button>
            </a-space>
          </a-form-item>
          <!--题目选项结束-->
        </div>
      </a-form-item>
      <a-form-item>
        <a-button html-type="submit" style="width: 120px" type="primary"
          >提交
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, reactive, ref, watchEffect, withDefaults } from "vue";
import { useRouter } from "vue-router";
import API from "@/api";
import {
  addQuestionUsingPost,
  editQuestionUsingPost,
  listQuestionVoByPageUsingPost,
} from "@/api/questionController";
import { Message } from "@arco-design/web-vue";
import AiGenerateQuestionDrawer from "./component/AiGenerateQuestionDrawer.vue";

const router = useRouter();

interface Props {
  appId: string;
}

const props = withDefaults(defineProps<Props>(), {
  appId: () => {
    return "";
  },
});

// 题目内容结构
const questionContent = ref<API.QuestionContentDTO[]>([]);

/*
 * 添加题目
 * */
const addQuestion = (index: number) => {
  questionContent.value.splice(index, 0, {
    title: "",
    options: [],
  });
};

/*
 * 删除题目
 * */
const deleteQuestion = (index: number) => {
  questionContent.value.splice(index, 1);
};

/*
 * 添加题目选项
 * */
const addQuestionOption = (question: API.QuestionContentDTO, index: number) => {
  if (!question.options) {
    question.options = [];
  }
  question.options.splice(index, 0, {
    key: "",
    value: "",
  });
};

/*
 * 删除题目选项
 * */
const deleteQuestionOption = (
  question: API.QuestionContentDTO,
  index: number
) => {
  if (!question.options) {
    question.options = [];
  }
  question.options.splice(index, 1);
};

const oldQuestion = ref<API.QuestionVO>();

const loadData = async () => {
  if (!props.appId) {
    return;
  }

  const res = await listQuestionVoByPageUsingPost({
    appId: props.appId as any,
    current: 1,
    pageSize: 1,
    sortField: "createTime",
    sortOrder: "descend",
  });
  if (res.data.code === 0 && res.data.data?.records) {
    oldQuestion.value = res.data.data?.records[0];
    if (oldQuestion.value) {
      questionContent.value = oldQuestion.value.questionContent ?? [];
    }
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

watchEffect(() => {
  loadData();
});

/*
 * 提交
 * */
const handleSubmit = async () => {
  if (!props.appId || !questionContent.value) {
    return;
  }
  let res: any;
  if (oldQuestion.value?.id) {
    res = await editQuestionUsingPost({
      id: oldQuestion.value.id,
      questionContentDTO: questionContent.value,
    });
  } else {
    res = await addQuestionUsingPost({
      appId: props.appId as any,
      questionContentDTO: questionContent.value,
    });
  }
  if (res.data.code === 0) {
    Message.success("操作成功，即将跳转应用详情页");
    setTimeout(() => {
      router.push({
        path: `/app/detail/${props.appId}`,
      });
    }, 3000);
  } else {
    Message.error("创建失败，" + res.data.message);
  }
};

/*
 * AI 生成题目成功后执行
 * */
const onAiGenerateSuccess = (result: API.QuestionContentDTO[]) => {
  questionContent.value = [...questionContent.value, ...result];
};

/*
 * AI 生成题目成功后执行
 * */
const onAiGenerateSuccessSSE = (result: API.QuestionContentDTO) => {
  questionContent.value = [...questionContent.value, result];
};

const onSSEStart = (event: MessageEvent) => {
  Message.success("开始生成");
};

const onSSEClose = (event: MessageEvent) => {
  Message.success("生成完毕");
};
</script>

<style scoped></style>
